import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const MANAGEMENT_ENDPOINTS = {
  CREATE_POOL_STAFF_RESULT: {
    method: EMethod.POST,
    url: "/management/interview/results/pool-staff",
    version: API_VERSION.V0,
  },
  GET_EOD_REPORTS_USER_LIST: {
    method: EMethod.POST,
    url: "/management/eod-reports/users",
    version: API_VERSION.V0,
  },
  CREATE_WORKING_STAFF_RESULT: {
    method: EMethod.POST,
    url: "/management/interview/results/working-staff",
    version: API_VERSION.V0,
  },
  CREATE_TEMPORARY_STAFF_RESULT: {
    method: EMethod.POST,
    url: "/management/interview/results/temporary-staff",
    version: API_VERSION.V0,
  },
  GET_STAFF_INTERVIEW_RESULT: {
    method: EMethod.GET,
    url: "/management/interview/results/{idStaff}",
    version: API_VERSION.V0,
  },
  GET_STAFF_INTERVIEW_RESULT_LIST: {
    method: EMethod.POST,
    url: "/management/interview/results/list/{idStaff}",
    version: API_VERSION.V0,
  },
  GET_KANBAN_TICKETS: {
    method: EMethod.POST,
    url: "/management/pipeline/kanban/{pipelineSlug}",
    version: API_VERSION.V0,
  },
  GET_USERS_PIPELINES: {
    method: EMethod.GET,
    url: "/management/pipeline",
    version: API_VERSION.V0,
  },
  GET_USERS_PIPELINE_STATUS_LIST: {
    method: EMethod.GET,
    url: "/management/pipeline/status/{pipelineSlug}",
    version: API_VERSION.V0,
  },
  GET_TAG_LIST: {
    method: EMethod.GET,
    url: "/management/tag/list",
    version: API_VERSION.V0,
  },
  CREATE_TAG: {
    method: EMethod.POST,
    url: "/management/tag",
    version: API_VERSION.V0,
  },
  UPDATE_TAG: {
    method: EMethod.PATCH,
    url: "/management/tag",
    version: API_VERSION.V0,
  },
  DELETE_TAG: {
    method: EMethod.DEL,
    url: "/management/tag",
    version: API_VERSION.V0,
  },
  DELETE_TICKET_ATTACHMENT: {
    method: EMethod.DEL,
    url: "/management/ticket/attachment/{idAttachment}",
    version: API_VERSION.V0,
  },
  GET_TICKET_DETAIL: {
    method: EMethod.GET,
    url: "/management/ticket/{pipelineSlug}/{idTicket}",
    version: API_VERSION.V0,
  },
  GET_TICKET_DETAIL_BY_STAFF_ID: {
    method: EMethod.GET,
    url: "/management/ticket/details/staff/{idStaff}",
    version: API_VERSION.V0,
  },
  UPDATE_TICKET: {
    method: EMethod.PATCH,
    url: "/management/ticket/{pipelineSlug}/{idTicket}",
    version: API_VERSION.V0,
  },
  GET_TICKET_LIST: {
    method: EMethod.POST,
    url: "/management/ticket/list",
    version: API_VERSION.V0,
  },
  GET_TICKET_NOTES_LIST: {
    method: EMethod.POST,
    url: "/management/ticket/notes/list",
    version: API_VERSION.V0,
  },
  GET_TAG_TICKET_COUNT: {
    method: EMethod.GET,
    url: "/management/tag/ticket/count/{idTag}",
    version: API_VERSION.V0,
  },
  ADD_TICKET_ATTACHMENT: {
    method: EMethod.POST,
    url: "/management/ticket/attachment",
    version: API_VERSION.V0,
  },
  CREATE_INSIDE_SALES_TICKET: {
    method: EMethod.POST,
    url: "/management/ticket/inside-sales",
    version: API_VERSION.V0,
  },
  CREATE_CUSTOMER_SUCCESS_TICKET: {
    method: EMethod.POST,
    url: "/management/ticket/customer-success",
    version: API_VERSION.V0,
  },
  CREATE_FIELD_SALES_TICKET: {
    method: EMethod.POST,
    url: "/management/ticket/field-sales",
    version: API_VERSION.V0,
  },
  CREATE_AD_HOC_TICKET: {
    method: EMethod.POST,
    url: "/management/ticket/ad-hoc-tasks",
    version: API_VERSION.V0,
  },
  GET_LIST_OPERATOR: {
    method: EMethod.POST,
    url: "/management/pipeline/list/operator",
    version: API_VERSION.V0,
  },
  GET_LIST_SALES: {
    method: EMethod.POST,
    url: "/management/pipeline/list/sales",
    version: API_VERSION.V0,
  },
  GET_LIST_CORPORATION: {
    method: EMethod.POST,
    url: "/management/pipeline/list/corporation",
    version: API_VERSION.V0,
  },
  GET_LIST_CUSTOMER_SUCCESS: {
    method: EMethod.POST,
    url: "/management/pipeline/list/customer-success",
    version: API_VERSION.V0,
  },
  GET_LIST_STAFF: {
    method: EMethod.POST,
    url: "/management/pipeline/list/staff",
    version: API_VERSION.V0,
  },
  REORDER_TICKET: {
    method: EMethod.PUT,
    url: "/management/pipeline/kanban/reorder/{idTicket}",
    version: API_VERSION.V0,
  },
  ARCHIVE_TICKET: {
    method: EMethod.POST,
    url: "/management/ticket/archive/{idTicket}",
    version: API_VERSION.V0,
  },
  GET_ACCESS_RIGHT_PRESET: {
    method: EMethod.GET,
    url: "/management/access-right/preset",
    version: API_VERSION.V0,
  },
  GET_ACCESS_RIGHT_LIST: {
    method: EMethod.GET,
    url: "/management/access-right/list",
    version: API_VERSION.V0,
  },
  GET_USER_ACCESS_RIGHT: {
    method: EMethod.GET,
    url: "/management/access-right",
    version: API_VERSION.V0,
  },
  UPDATE_USER_ACCESS_RIGHT: {
    method: EMethod.PUT,
    url: "/management/access-right",
    version: API_VERSION.V0,
  },
  GET_EOD_REPORT_LIST: {
    method: EMethod.POST,
    url: "/management/eod-reports/list",
    version: API_VERSION.V0,
  },
  GET_EOD_REPORTING_LINE: {
    method: EMethod.GET,
    url: "/management/eod-reports/reporting-line/{date}",
    version: API_VERSION.V0,
  },
  COMPLETE_EOD_REPORT: {
    method: EMethod.POST,
    url: "/management/eod-reports/complete/{date}",
    version: API_VERSION.V0,
  },
  GET_EOD_REPORT_DETAILS: {
    method: EMethod.GET,
    url: "/management/eod-reports/details/{date}/{idTicket}",
    version: API_VERSION.V0,
  },
  UPDATE_EOD_REPORT_DETAILS: {
    method: EMethod.PUT,
    url: "/management/eod-reports/details/{date}/{idTicket}",
    version: API_VERSION.V0,
  },
  SUBMIT_EOD_REPORT_DETAILS: {
    method: EMethod.POST,
    url: "/management/eod-reports/details",
    version: API_VERSION.V0,
  },
  GET_PENDING_EOD: {
    method: EMethod.GET,
    url: "/management/eod-reports/pending",
    version: API_VERSION.V0,
  },
  GET_LIST_SCORECARD: {
    method: EMethod.POST,
    url: "/management/scorecards/list/{entityType}/{idTicket}",
    version: API_VERSION.V0,
  },
  GET_SCORECARD_DETAILS: {
    method: EMethod.GET,
    url: "/management/scorecards/{idScorecard}",
    version: API_VERSION.V0,
  },
  CREATE_SCORECARD_STAFF: {
    method: EMethod.POST,
    url: "/management/scorecards/staff",
    version: API_VERSION.V0,
  },
  UPDATE_SCORECARD_STAFF: {
    method: EMethod.PATCH,
    url: "/management/scorecards/staff/{idScorecard}",
    version: API_VERSION.V0,
  },
  CREATE_SCORECARD_CLIENT: {
    method: EMethod.POST,
    url: "/management/scorecards/client",
    version: API_VERSION.V0,
  },
  UPDATE_SCORECARD_CLIENT: {
    method: EMethod.PATCH,
    url: "/management/scorecards/client/{idScorecard}",
    version: API_VERSION.V0,
  },
};
